import React, { useState, FC, useContext, useEffect, useMemo } from "react";
import { IArticle } from "../../models/IArticle";
import ImageLoader from "../../components/imageLoader/ImageLoader";
import Button from "../../components/UI/button/GgButton";
import Input from "../../components/UI/input/GgInput";
import JoditEditor from "jodit-react";
import { Context } from "../..";
import { setTags } from "../../utils";
import CustomSelect from "../../components/UI/customSelect/CustomSelect";
import { useSelect } from "../../customHooks/useSelect";
import SunEditorComponent from "../../components/UI/editor/SunEditor";
import { Editor } from "../../components/UI/editor/QuillEditor";

interface IArticleForm {
  data?: IArticle;
  onClose: () => void;
  page?: number;
  actionData: any;
}

const ArticleForm: FC<IArticleForm> = ({ data, onClose, page, actionData }) => {
  const { articles } = useContext(Context);
  const [formData, setFormData] = useState<IArticle>(data as IArticle);
  const [bannerImage, setBannerImage] = useState<string>("");
  const [tags, setNewTags] = useState("");
  const statusSelect = useSelect();
  // const positionSelect = useSelect();
  const bannerSelect = useSelect();

  useEffect(() => {
    if (data !== undefined) {
      setFormData(data);
      setNewTags(data.tags.join(", "));
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      // position: positionSelect.selected?.value,
      status: statusSelect.selected?.value,
      banner: bannerSelect.selected?.value,
    });
    //eslint-disable-next-line
  }, [
    // positionSelect.selected,
    statusSelect.selected,
    bannerSelect.selected,
  ]);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const formatedData = {
      ...formData,
      tags: setTags(tags),
      banner: formData.banner === "show" ? true : false,
    };
    if (!bannerImage) {
      return alert("Please, add image");
    }

    if (data === undefined) {
      articles
        .createOne(
          { ...formatedData, created_at: new Date(), mainImage: bannerImage },
          page
        )
        .then();
    } else {
      articles
        .updateOne(
          { ...formatedData, updated_at: new Date(), mainImage: bannerImage },
          page
        )
        .catch(console.log);
    }
    onClose();
  }

  function resetForm() {
    setFormData({} as IArticle);
  }

  return (
    <form className="articles-modal" onSubmit={handleSubmit}>
      <ImageLoader
        label="Add image"
        value={formData?.mainImage}
        type={1}
        onChange={(img) => {
          setBannerImage(img);
          console.log(
            "img - это уже картинка в base64 или при  параметре multi=true массив картинок в формате base64"
          );
        }}
      />
      <Input
        type="text"
        label="Add a title"
        id="post-title"
        value={formData?.name || ""}
        placeholder="Title"
        required={true}
        onChange={(value) => setFormData({ ...formData, name: value })}
      />
      <div className="add-desc">
        <div className="label">Add description</div>
        <Editor
          value={formData?.content}
          onChange={(value) => setFormData({ ...formData, content: value })}
          placeholder="Enter content"
          style={{
            height: "16rem",
            marginBottom: "1rem",
          }}
          readOnly={!actionData?.add && !actionData?.edit}
        />
      </div>
      <Input
        type="text"
        label="Add a category"
        id="post-tag"
        required={true}
        value={tags}
        placeholder="Category"
        onChange={(value) => setNewTags(value)}
      />

      <Input
        type="text"
        label="Posted By"
        id="post-tag"
        required={true}
        value={formData?.postedBy || ""}
        placeholder="Posted by"
        onChange={(value) => setFormData({ ...formData, postedBy: value })}
      />
      <div className="input-row">
        <div className="select-group">
          <CustomSelect
            selected={formData?.status ? formData?.status : "show"}
            defaultValue="Active"
            list={[
              { value: "show", label: "Active", default: true },
              { value: "hidden", label: "Archive" },
            ]}
            onChange={statusSelect.handleSelect}
          />
          <CustomSelect
            selected={
              formData?.banner
                ? formData?.banner === "show"
                  ? "show"
                  : "hidden"
                : "hidden"
            }
            defaultValue="No Banner"
            list={[
              { value: "show", label: "Banner" },
              { value: "hidden", label: "No Banner", default: true },
            ]}
            onChange={bannerSelect.handleSelect}
          />
          {/* <CustomSelect
            selected={formData?.position ? formData?.position : "show"}
            defaultValue="Active"
            list={[
              { value: "default", label: "Default", default: true },
              { value: "hidden", label: "Archive" },
            ]}
            disabled={true}
            onChange={positionSelect.handleSelect}
          /> */}
        </div>
        <div className="btn-group">
          <Button
            label="Reset"
            type="reset"
            stylesType="border"
            onPress={resetForm}
          />
          <Button label="Save" type="submit" />
        </div>
      </div>
    </form>
  );
};

export default ArticleForm;
